import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../contexts/AuthContext";
import "./Login.css";
import Swal from "sweetalert2";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { loginUser } = useContext(AuthContext);
  const navigate = useNavigate();

  function handleClick() {
    navigate('/grid');
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const jsonSend = {
      email,
      password,
    };
    const LOGIN_URL = import.meta.env.VITE_URL_LOGIN;
    try {
      const res = await axios.post(LOGIN_URL, jsonSend);
      loginUser(res.data.token);
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Bienvenido",
        showConfirmButton: false,
        timer: 2000,
      });
      handleClick();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        {/* Logo */}
        <div className="login-logo-container">
          <img
            src="/Logo-Sistemify-Login.png"
            alt="GridBot Trading Platform"
            className="login-logo"
          />
        </div>

        {/* Title */}
        <h1 className="login-title">Bienvenido</h1>
        <p className="login-subtitle">Ingresa a tu cuenta para continuar</p>

        {/* Form */}
        <form onSubmit={handleSubmit} className="login-form">
          {/* Email Input */}
          <div className="login-form-group">
            <label htmlFor="emailInput" className="login-label">
              Email
            </label>
            <input
              id="emailInput"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              placeholder="tu@email.com"
              className="login-input"
              required
            />
          </div>

          {/* Password Input */}
          <div className="login-form-group">
            <label htmlFor="passwordInput" className="login-label">
              Contraseña
            </label>
            <input
              id="passwordInput"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              placeholder="Ingresa tu contraseña"
              className="login-input"
              required
            />
          </div>

          {/* Submit Button */}
          <button type="submit" className="login-button">
            Iniciar Sesión
          </button>
        </form>

        {/* Footer Links */}
        <div className="login-footer">
          <a href="/signup" className="login-footer-link">
            ¿No tienes cuenta? Regístrate aquí
          </a>
        </div>
      </div>
    </div>
  );
};

export default Login;
